export default function getResource(label, vars = []) {
    const resources = { continueShopping: 'Continuer à magasiner' };
    return resources[label];
}
